export const CYCLE_VIDEO_DEVICE = 'events/CYCLE_VIDEO_DEVICE';

/**
 * @return {{type: string}}
 */
export const cycleVideoDevices = (payload) => ({ type: CYCLE_VIDEO_DEVICE, payload });
